export const TELLER_LIST_DEFAULT = 'teller_list_default'
export const TELLER_LIST_DEFAULT_HOME = 'teller_list_default_home'
export const TELLER_LIST = 'teller_list'
export const TELLER_LIST_HOME = 'teller_list_home'
export const TELLER_LIST_FAV = 'teller_list_fav'
export const TELLER_LIST_RECOMMENDED = 'teller_list_recommended'
